import React from "react";
import { CifradoAES, CifradoRSA } from "../../components/FuncionesCifrado";
import Drive from "./Drive";
//import { Fotos } from "./Fotos";
import { BASE_URL } from "../../config/api";
//import SubirArchivos from "./SubirArchivos";
import SubirArchivos from "./SubirArchivos";
import axios from "axios";
import { withRouter } from "../../../src/utils/withRouter";
//import { VisualizadorArchivos } from "./VisualizadorArchivos";

class DrivePrincipal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pantallaActual: "EXPLORADOR_ARCHIVOS",
            espacio:0,
            servicios: [],
            paquetes: [],
            listaPaquetes: [],
            pagoActual: '',
            busqueda:'',
            ok:false,
            showModal:false,
            isMobile: window.innerWidth < 768,
            windowWidth: window.innerWidth,
            tokenSeguridad:'xjC237RGCVCjFC6T8o25BScT2E3H9iPACvoPwn3RHB8ZHsZzmsnqJrydG4MrZrWLFXyKbU244vJYjMTTGSTB4cJDubWr8S7azn4fAJfRA6M3GQZDRi3LZbUXLqTV5DHi',
            publicKeyRSA:'',
            sideBarBig: true,
            sideBarSmall: false,
            iconos:[{
                inicio: 'bi-house-door-fill',
                inicioActivo: 'bi-house-door',
                archivos: 'bi-folder',
                archivosActivos: 'bi-folder-fill',
                compartidos: 'bi-people',
                compartidosActivo: 'bi-people-fill',
                conf: 'bi-gear'
            }],
            activeTab:'inicio',
            activeType: 'files',
            ubicacion: '/',
            idCarpeta: '',
            carpeta:'',
            directorioArchivos: [],
            directorioArchivosRecientes: [],
            tema:'light',

        }
        this.myRef = React.createRef();
        this.resizeTimeout;
        this.anteriorSeleccionado = "";
        this.aesEncryption = new CifradoAES();
        this.rsaEncryption = new CifradoRSA();

        this.abrirModal = this.abrirModal.bind(this);
        this.formatBytes = this.formatBytes.bind(this);
        this.buscarArchivo = this.buscarArchivo.bind(this);
        this.pedirPaquetes = this.pedirPaquetes.bind(this);        
        this.listarPaquetes = this.listarPaquetes.bind(this);        
        this.obtenerArchivos = this.obtenerArchivos.bind(this);
        this.obtenerServicios = this.obtenerServicios.bind(this);
        this.cambiarUbicacion = this.cambiarUbicacion.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        
    };
    componentDidMount() {
        document.documentElement.setAttribute('data-bs-theme', this.state.tema);
        this.fetchPublicKey();
        this.handleWindowResize(); 
        
        // Handle initial window size
        //window.addEventListener('resize', this.handleWindowResize);
    }
    componentWillUnmount() {
        // Clean up
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        //window.removeEventListener('resize', this.handleWindowResize);
    }
    componentDidUpdate(prevState){
        /* if (prevState.paquetes !== this.state.paquetes) {
            this.listarPaquetes();
        } */
        if (prevState.tema !== this.state.tema) {
            document.documentElement.setAttribute('data-bs-theme', this.state.tema);
        }
    }
    // fetching the key
    fetchPublicKey = async () => {
        try {
            const formData = new FormData();
            const response = await fetch(`${BASE_URL}/cratos/ModuloSesion/PHP/Implementaciones/pedirLlavePublica.php`, {
                method: 'POST',
                body: formData,
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const publicKey = await response.text();
            
            this.setState({ publicKeyRSA: publicKey }, () => {
                this.pedirPaquetes();
                this.obtenerServicios(); 
                //this.obtenerArchivos(this.state.activeTab);// Call after state is set
                
            });
            
        } catch (error) {
            console.error('Error fetching public key:', error);
            alert("Error Cifrado Asimetrico: " + error.message);
        }
    }
    // window resize
    handleWindowResize = () => {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        
        this.resizeTimeout = setTimeout(() => {
            const newWidth = window.innerWidth;
            const newIsMobile = newWidth < 768;
            
            this.setState({
                isMobile: newIsMobile,
                windowWidth: newWidth
            });
        }, 100);
    }
    formatBytes = (bytes) => {
        var marker = 1000;//1024; // Change to 1000 if required
        var decimal = 2; // Change as required
        var kiloBytes = marker; // One Kilobyte is 1024 bytes
        var megaBytes = marker * marker; // One MB is 1024 KB
        var gigaBytes = marker * marker * marker; // One GB is 1024 MB
        var teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

        // return bytes if less than a KB
        if (bytes < kiloBytes) return bytes + " Bytes";
        // return KB if less than a MB
        else if (bytes < megaBytes) return (bytes / kiloBytes).toFixed(decimal) + " KB";
        // return MB if less than a GB
        else if (bytes < gigaBytes) return (bytes / megaBytes).toFixed(decimal) + " MB";
        // return GB if less than a TB
        else return (bytes / gigaBytes).toFixed(decimal) + " GB";

        /* if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]; */
    }
    pedirPaquetes = async () => {
        try {
            const token = this.state.tokenSeguridad;
            const formData = new FormData();
            formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
            formData.append("t_u", sessionStorage.getItem('token_nk107803'));
            formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
            formData.append("t_seg", token);
    
            //Cifrando Envío
            for (let dato of formData.entries()) {
                formData.set(dato[0], this.aesEncryption.cifrar(dato[1]).datos)
            }
            let llaveCifrada = await this.rsaEncryption.cifrar(this.aesEncryption.llave, this.state.publicKeyRSA);
            formData.append("ivCifradoSimetrico", this.aesEncryption.iv);
            formData.append("keyCifradoSimetrico", llaveCifrada);
    
            const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/obtenerPaquetesUsuario.php`;
            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const res = await response.text();
            try {
                if (parseInt(res) != 0) {
                    let datos = JSON.parse(res);
                    this.setState({ paquetes: datos },()=>{
                        this.listarPaquetes();
                    });
                }
            } catch (err) {
                alert("Error paquetes");
                console.error('Error:', err);
            }
        } catch (error) {
            console.error('Error fetching paquetes:', error);
            alert("Error paquetes: " + error.message);
        }    
    }
    obtenerServicios = async () => {
        try {
            const token = this.state.tokenSeguridad;
            const formData = new FormData();
            formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
            formData.append("t_u", sessionStorage.getItem('token_nk107803'));
            formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
            formData.append("t_seg", token);

            //Cifrando Envío
            for (let dato of formData.entries()) {
                formData.set(dato[0], this.aesEncryption.cifrar(dato[1]).datos)
            }
            let llaveCifrada = await this.rsaEncryption.cifrar(this.aesEncryption.llave, this.state.publicKeyRSA);
            formData.append("ivCifradoSimetrico", this.aesEncryption.iv);
            formData.append("keyCifradoSimetrico", llaveCifrada);

            const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/obtenerServicios.php`;
            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const res = await response.text();
            console.log(res);
            try {
                let datos = JSON.parse(res);
                //console.log(datos);
                const usedNum = parseFloat(datos.usado);
                const limitNum = parseFloat(datos.cantidad);
                const pg = limitNum > 0 ? (usedNum / limitNum) * 100 : 0;
                const espacio = {pg: pg, total: datos.restante_espacio};
                //console.log('ares',espacio);
                this.setState({ servicios: datos, espacio: espacio });
            } catch (err) {
                console.error('Error de Servicios:', err);
            }            
        } catch (error) {
            console.error('Error fetching servicio:', error);
            alert("Error servicio: " + error.message);
        }
    }
    listarPaquetes = async () => {
        let ListaPaquetes = []; 
        this.state.paquetes.map((paquete,i) => {
            if (i == 0) {
                ListaPaquetes.push(<a href="#" key={'pqt-'+i} className="list-group-item list-group-item-action disabled border-info">
                Paquete Actual: {paquete.nombre} - {this.formatBytes(paquete.espacio)} <b>${paquete.costo}/mes</b> </a>)
            }else{
                ListaPaquetes.push(<a id={"paquete_precio_" + paquete.id_precio} onClick={(e) => {
                    e.preventDefault();
                    let etiqueta = document.getElementById("paquete_precio_" + paquete.id_precio);
                    if (this.anteriorSeleccionado != etiqueta) {
                        etiqueta.classList.add("active");
                        if (this.anteriorSeleccionado != "")
                            this.anteriorSeleccionado.classList.remove("active");
                            this.setState({ pagoActual: paquete });
                            this.anteriorSeleccionado = etiqueta;
                    }
                }}
                href="#" className="list-group-item list-group-item-action">Comprar: {paquete.nombre} - {this.formatBytes(paquete.espacio)} 
                <span className="">{`${paquete.costo = -1 ? '' : paquete.costo}/mes`}</span> 
                <span className="text-success">Paga este mes: ${paquete.costo_descuento}</span>
                </a>);
            }            
        });
        this.setState({listaPaquetes: ListaPaquetes})
        return;
    }
    abrirModal = () => {
        this.setState({showModal: true});
    };
    cambiarUbicacion = async (id, nombre_carpeta, tab) => {
        const { ubicacion: currentDir, carpeta: currentFolder } = this.state;
        
        let newUbicacion;
        let newCarpeta;
        
        // Handle navigation to root
        if (nombre_carpeta === '/') {
            newUbicacion = '/';
            newCarpeta = '';
        }
        // Handle navigation from root
        else if (currentDir === '/') {
            newUbicacion = nombre_carpeta;
            newCarpeta = id;
        }
        // Handle navigation deeper into folders
        else {
            newUbicacion = `${currentDir}/${nombre_carpeta}`;
            newCarpeta = `${currentFolder}/${id}`;
        }
        
        this.setState(
            { 
                ubicacion: newUbicacion, 
                idCarpeta: id, 
                carpeta: newCarpeta 
            }, 
            () => {
                this.obtenerArchivos(tab);
            }
        );
    }
    regresarDirectorio = async () => {
        const { ubicacion, carpeta, idCarpeta } = this.state;
        
        // Don't navigate if already at root
        if (ubicacion === "/") {
            return;
        }
        
        const pathParts = ubicacion.split("/");
        const folderParts = carpeta.split("/");
        
        // Remove the last segment from both paths
        pathParts.pop();
        folderParts.pop();
        
        // Determine new values
        const newUbicacion = pathParts.length > 0 ? pathParts.join("/") : "/";
        const newCarpeta = folderParts.join("/");
        const newId = folderParts.length > 0 ? folderParts[folderParts.length - 1] : '';
        
        // Update state and fetch files
        this.setState(
            { 
                ubicacion: newUbicacion, 
                carpeta: newCarpeta, 
                idCarpeta: newId 
            }, 
            () => {
                this.obtenerArchivos(this.state.activeTab);
            }
        );
    }
    obtenerArchivos = async (tab) => {
        console.log('obtenerArchivos', tab);
        const token = this.state.tokenSeguridad;
        const ubicacion = this.state.ubicacion;
        const idCarpeta = this.state.idCarpeta;
        const formData = new FormData();
        formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
        formData.append("t_u", sessionStorage.getItem('token_nk107803'));
        formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
        formData.append("t_seg", token);
        formData.append("ubicacion", ubicacion);
        formData.append("id_carpeta", idCarpeta);
        if (tab == 'inicio') {
            formData.append("recientes", 1);
        }
        if (tab == 'compartir') {
            formData.append("compartir", 1);
        }
        //Cifrando Envío
        for (let dato of formData.entries()) {
            formData.set(dato[0], this.aesEncryption.cifrar(dato[1]).datos)
        }
        let llaveCifrada = await this.rsaEncryption.cifrar(this.aesEncryption.llave, this.state.publicKeyRSA);
        formData.append("ivCifradoSimetrico", this.aesEncryption.iv);
        formData.append("keyCifradoSimetrico", llaveCifrada);

        const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/obtenerArchivos.php`;
        axios({
            url: url,
            method: "POST",
            data: formData,
            responseType: "text"
        }).then((response) => {
            try {
                let datos = JSON.parse(response.data, (key, value) => {
                    if (key == 'tamanio') {
                        return Number(value);
                    }
                    return value;
                });
                this.setState({ directorioArchivos: datos, busqueda: "" });
            } catch (error) {
                console.error('Error obtenerArchivos:', error);
            }
        }).catch(function (response) {
            console.error('Error obtenerArchivos:', response);
        });
    }
    buscarArchivo = async () => {
        const busqueda = this.state.busqueda;
        if (busqueda == '') {
                this.obtenerArchivos(this.state.activeTab);
            return;
        }
        const likePattern = `%${busqueda}%`;
        const regexPattern = busqueda.replace(/\s+/g, '.*');
        const formData = new FormData();
        formData.append("id_usuario", sessionStorage.getItem('id_usuario'));
        formData.append("t_u", sessionStorage.getItem('token_nk107803'));
        formData.append("tip_u", sessionStorage.getItem('tipo_usuario'));
        formData.append("t_seg", this.state.tokenSeguridad);
        formData.append("busqueda", busqueda);
        formData.append("likePattern", likePattern);
        formData.append("regexPattern", regexPattern);
        //Cifrando Envío
        for (let dato of formData.entries()) {
            formData.set(dato[0], this.aesEncryption.cifrar(dato[1]).datos)
        }
        let llaveCifrada = await this.rsaEncryption.cifrar(this.aesEncryption.llave, this.state.publicKeyRSA);
        formData.append("ivCifradoSimetrico", this.aesEncryption.iv);
        formData.append("keyCifradoSimetrico", llaveCifrada);

        const url = `${BASE_URL}/cratos/ModuloDrive/PHP/Implementaciones/buscarArchivo.php`;
        axios({
            url: url,
            method: "POST",
            data: formData,
            responseType: "text"
        }).then((response) => {
            let text = response.data;
            if (parseInt(text) != 0) {
                let datos = JSON.parse(text);
                this.setState({ directorioArchivos: datos });
            }
        }).catch(function (response) {
            alert("Error de conexión");
            console.error(response);
        });
    }
    render() {
        let movil = [];
        let desktop = [];
        let render = desktop;
        let dWidth = '250px';
        let isMobile = this.state.isMobile;
        let nombreUsuario = sessionStorage.getItem("nombre");
        let nombres = sessionStorage.getItem("nombre").split(' ');
        let correo = sessionStorage.getItem("correo");
        if (isMobile) {
            return (<>
            <header className="navbar sticky-top p-2" style={{height:'auto'}}>
                <div className="container-fluid">
                    <div className="col-2 d-flex align-items-center dropdown">
                        <button className="btn avatar-circle border border-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            {nombres[0].charAt(0)}{nombres[1].charAt(0)}
                        </button>
                        <div className="dropdown-menu text-small shadow" style={{width: '90vw', left:'-5px'}}>
                            <div className="row">
                                <div className="col-12">
                                    <span className="fs-5 p-1">Box</span>
                                    <a className="btn float-end" href="#" onClick={(e) => { e.preventDefault(); sessionStorage.clear(); window.location = "https://neurokratos.space/sesion/" }}>
                                        <i className="bi bi-box-arrow-left"></i>    Cerrar Sesión</a>
                                </div>
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-4 text-center mt-auto">
                                            <div className="placeholder rounded-circle" style={{width:'70px', height:'70px'}}></div>
                                        </div>
                                        <div className="col-8">
                                            <span className="fs-4">{nombreUsuario}</span>
                                            <br/>
                                            <span className="fs-6">{correo}</span>
                                            <br/>
                                            <a className="" href="#">
                                                <i className="bi bi-person-fill-gear"></i>  Ver cuenta</a>
                                        </div>
                                    </div>
                                    <hr/>
                                </div>
                                <div className="col-12">
                                    <div className="p-1 mb-3">
                                            <label className="col-sm-2 col-form-label">Tema</label>
                                            <div className="col-sm-10">
                                                <select className="form-select" onChange={(e)=>{
                                                    this.setState({tema: e.currentTarget.value});
                                                }}>
                                                    <option defaultValue="light">Claro</option>
                                                    <option value="dark">Oscuro</option>
                                                </select>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 text-center mx-auto">
                        <div className="btn-group">
                            <a href="#" className={`btn btn-show ${this.state.activeType == 'img' ? 'active' : ''}`} onClick={(e)=>{
                                e.preventDefault();
                                this.setState({
                                    activeType:'img'
                                });
                                }}>Fotos</a>
                            <a href="#" className={`btn btn-show ${this.state.activeType == 'files' ? 'active' : ''}`} onClick={(e)=>{
                                e.preventDefault();
                                this.setState({
                                    activeType:'files'
                                });
                                }}>Archivos</a>                        
                        </div>
                    </div>
                    <div className="col-2 text-center"></div>
                    <div className="col-2 text-center">
                        <button className="btn btn-mas" id="btnPaquetesHeader" onClick={(e) => {
                            e.preventDefault();
                            this.abrirModal();
                        }}>
                            <i className="bi bi-gem text-primary"></i>
                        </button>
                        <div className="col-2 text-center d-none">
                            <div className="dropstart">
                                <a className="btn-settings dropdown-toggle text-secondary" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="bi bi-gear fs-3"></i>
                                </a>
                                <div className="dropdown-menu pt-0 mx-0 rounded-3 shadow overflow-hidden" style={{width:'300px'}}>
                                    <div className="p-2 mb-3 row">
                                        <label className="col-sm-2 col-form-label">Tema</label>
                                        <div className="col-sm-10">
                                            <select className="form-select" onChange={(e)=>{
                                                this.setState({tema: e.currentTarget.value});
                                            }}>
                                                <option defaultValue="light">Claro</option>
                                                <option value="dark">Oscuro</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className={`nav nav-pills nav-fill mt-2`} role="tablist" style={{fontSize:'.8rem'}}>
                        <li key={"menuInicio"} className="nav-item mb-2" id="menuLateral-inicio" role="presentation">
                            <a href="#" className={`nav-link topMenu ${this.state.activeTab === 'inicio' ? 'active' : ''}`}
                                id="pills-recientes-tab" data-bs-toggle="pill" data-bs-target="#pills-recientes" type="button" role="tab" aria-selected="true" onClick={()=>{
                                    this.setState({activeTab:  'inicio',  ubicacion: '/', idCarpeta: '', carpeta:''});
                                }}>
                                <i className="bi bi-house-door-fill mx-2 iconoSidebar" ></i>
                                <i className="bi bi-house-door mx-2" ></i>
                                <br/>
                                Inicio                             
                            </a>
                        </li>
                        <li key={"menuArchivos"} className="nav-item mb-2" id="menuLateral-EXPLORADOR_ARCHIVOS" role="presentation">
                            <a href="#" className={`nav-link topMenu ${this.state.activeTab === 'archivos' ? 'active' : ''}`}
                                id="pills-explorador-tab" data-bs-toggle="pill" data-bs-target="#pills-explorador" type="button" role="tab" aria-selected="true" onClick={()=>{
                                    this.setState({activeTab:  'archivos',  ubicacion: '/', idCarpeta: '', carpeta:''});
                                }}>
                                <i className="bi bi-folder-fill mx-2 iconoSidebar"></i>
                                <i className="bi bi-folder mx-2"></i>
                                <br/>
                                Mis Archivos
                            </a>
                        </li>
                        <li key={"menuCompartir"} className="nav-item mb-2" id="menuLateral-compartir" role="presentation">
                            <a href="#" className={`nav-link topMenu ${this.state.activeTab === 'compartir' ? 'active' : ''}`}
                                id="pills-compartir-tab" data-bs-toggle="pill" data-bs-target="#pills-compartir" type="button" role="tab" aria-selected="false" onClick={()=>{
                                    this.setState({activeTab:  'compartir',  ubicacion: '/', idCarpeta: '', carpeta:''});
                                }}>
                                <i className='bi bi-people-fill mx-2 iconoSidebar'></i>
                                <i className='bi bi-people mx-2'></i>
                                <br/>
                                Compartido
                            </a>
                        </li>
                        {/* <li key={"menuAlmacen"} className="nav-item mb-2" id="menuLateral-almacen" role="presentation">
                            <a href="#" className={`nav-link topMenu ${this.state.activeTab === 'almacen' ? 'active' : ''}`}
                                id="pills-almacen-tab" data-bs-toggle="pill" data-bs-target="#pills-almacen" type="button" role="tab" aria-selected="false" onClick={()=>{
                                    this.setState({activeTab:  'almacen',  ubicacion: '/', idCarpeta: '', carpeta:''});
                                }}>
                                <i className='bi bi-safe-fill mx-2 iconoSidebar'></i>
                                <i className='bi bi-safe mx-2'></i>
                                <br/>
                                Almacén
                            </a>
                        </li> */}
                    </ul>
                </div>
            </header>

            <div className="col px-1"  style={{ height: '80vh', width: dWidth}}>
                <Drive pkey={this.state.publicKeyRSA} 
                    activeTab={this.state.activeTab}
                    ubicacion={this.state.ubicacion} 
                    cambiarUbicacion={this.cambiarUbicacion}
                    idCarpeta={this.state.idCarpeta}
                    regresarDirectorio={this.regresarDirectorio}
                    files={this.state.directorioArchivos}
                    obtenerArchivos={this.obtenerArchivos}
                    activeType={this.state.activeType}
                    movil={true}/>
            </div>
            <div className="row" style={{bottom: '10px', position: 'fixed', zIndex:'1020'}}>                            
                <div className="col-12 input-group ms-2">
                    <span className="input-group-text border-end-0 shadow buscar"><i className="bi bi-search text-secondary"></i></span>
                    <input type="search" className="form-control border-start-0 shadow" id="inputBuscarDrive" value={this.state.busqueda} onChange={(e)=>{
                    e.preventDefault();
                    this.setState({
                        busqueda:e.currentTarget.value
                    },()=>{this.buscarArchivo()});
                    }} placeholder="Búsqueda"/>
                    <SubirArchivos 
                    tokenSeguridad={this.state.tokenSeguridad} 
                    ubicacion={this.state.ubicacion}
                    idCarpeta={this.state.idCarpeta}
                    publicKeyRSA={this.state.publicKeyRSA}
                    activeTab={this.state.activeTab}
                    obtenerArchivos={this.obtenerArchivos}
                    sideBarBig={false}
                    movil={true}/>
                </div>
            </div>
            {this.state.showModal && (
                <div className="modal show d-block" id="PagosModal" tabIndex="-1" data-bs-backdrop="static">
                <div className="modal-backdrop show z-n1"></div>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="PagosModalLabel">Paquetes</h5>
                    </div>
                    <div className="modal-body">
                        <div className="list-group">
                            <div>
                                {this.state.listaPaquetes}
                                <div className="row">
                                    {this.state.pagoActual != "" ?
                                    <button onClick={() => { return;}} className="btn btn-success">Continuar</button> : null}
                                </div>
                            </div>
                            {/* <BotonPagoDrive id_usuario={sessionStorage.getItem('id_usuario')} precio={this.state.pagoActual.costo} id_precio={this.state.pagoActual.id_precio} />  */}
                        
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button id="CerrarModalPago" onClick={() => { 
                            this.setState({ paquetes: [], pagoActual: "", showModal: false });
                            }} type="button" className="btn btn-secondary">Cerrar</button>
                    </div>
                    </div>
                </div>
                </div>
            )}       
            </>);
        }

        // Desktop view
        return (<>
            <div className="navbar sticky-top p-2" style={{ height:'10vh'}}>
                <div className="container-fluid">
                    <div className="col-2 text-center" style={{maxWidth:'250px'}}>
                        <a className="navbar-brand" href="#">
                                <img src="../img/logo.svg" width={'45'} height={'45'}/>
                        </a>
                    </div>
                    <div className="col-2">
                        <div className="btn-group">
                            <a href="#" className={`btn btn-show ${this.state.activeType == 'img' ? 'active' : ''}`} onClick={(e)=>{
                                e.preventDefault();
                                this.setState({
                                    activeType:'img'
                                });
                                }}>Fotos</a>
                            <a href="#" className={`btn btn-show ${this.state.activeType == 'files' ? 'active' : ''}`} onClick={(e)=>{
                                e.preventDefault();
                                this.setState({
                                    activeType:'files'
                                });
                                }}>Archivos</a>                        
                        </div>
                    </div>
                    <div className="col-4">                            
                            <div className="input-group">
                                <span className="input-group-text border-end-0 shadow buscar"><i className="bi bi-search text-secondary"></i></span>
                                <input type="search" className="form-control border-start-0 shadow" id="inputBuscarDrive" value={this.state.busqueda} onChange={(e)=>{
                                e.preventDefault();
                                this.setState({
                                    busqueda:e.currentTarget.value
                                },()=>{this.buscarArchivo()});
                                }} placeholder="Búsqueda"/>
                            </div>
                    </div>
                    <div className="col-4">
                        <div className="row">
                            <div className="col-8 my-auto">
                                <button className="btn btn-mas float-end w-75 text-nowrap text-truncate" id="btnPaquetesHeader" onClick={(e) => {
                                e.preventDefault();
                                this.abrirModal();
                                }}>
                                    <i className="bi bi-gem text-primary"></i>  Comprar más espacio
                                </button>
                            </div>
                            <div className="col-2 text-center">
                                <div className="dropstart">
                                    <a className="btn-settings dropdown-toggle text-secondary" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-gear fs-3"></i>
                                    </a>
                                    <div className="dropdown-menu pt-0 mx-0 rounded-3 shadow overflow-hidden" style={{width:'300px'}}>
                                        <div className="p-2 mb-3 row">
                                            <label className="col-sm-2 col-form-label">Tema</label>
                                            <div className="col-sm-10">
                                                <select className="form-select" onChange={(e)=>{
                                                    this.setState({tema: e.currentTarget.value});
                                                }}>
                                                    <option defaultValue="light">Claro</option>
                                                    <option value="dark">Oscuro</option>
                                                </select>
                                            </div>
                                        </div>
                                        <ul></ul>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-2 d-flex align-items-center dropdown">
                                <button className="btn avatar-circle border border-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    {nombres[0].charAt(0)}{nombres[1].charAt(0)}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end text-small shadow">
                                    <li key={'cerrarSesion'}>
                                        <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); sessionStorage.clear(); window.location = "https://neurokratos.space/drive/" }}>
                                            <i className="bi bi-box-arrow-left"></i>    Cerrar Sesión</a>
                                    </li>
                                </ul>
                            </div> */}
                            <div className="col-2 d-flex align-items-center dropdown">
                                <button className="btn avatar-circle border border-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    {nombres[0].charAt(0)}{nombres[1].charAt(0)}
                                </button>
                                <div className="dropdown-menu dropdown-menu-end text-small shadow" style={{width:'35vw', right:'5px'}}>
                                    <div className="row">
                                        <div className="col-12">
                                            <span className="fs-5 p-1">Box</span>
                                            <a className="btn float-end" href="#" onClick={(e) => { e.preventDefault(); sessionStorage.clear(); window.location = "https://neurokratos.space/drive/" }}>
                                                <i className="bi bi-box-arrow-left"></i>    Cerrar Sesión</a>
                                        </div>
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-4 text-center mt-auto">
                                                    <div className="placeholder rounded-circle" style={{width:'70px', height:'70px'}}></div>
                                                </div>
                                                <div className="col-8">
                                                    <span className="fs-4">{nombreUsuario}</span>
                                                    <br/>
                                                    <span className="fs-6">{correo}</span>
                                                    <br/>
                                                    <a className="" href="#">
                                                        <i className="bi bi-person-fill-gear"></i>  Ver cuenta</a>
                                                </div>
                                            </div>
                                            <hr/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="float-end">
                        <button className="btn btn-dark" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                            <i className="bi bi-list"></i>
                        </button>
                    </div> */}
                </div>
            </div>
            <div className="d-flex flex-column flex-shrink-0 p-2 barraLateral" style={{ height: '90vh', width: this.state.sideBarBig ? dWidth: '4.5rem'}}>         
                <ul className={`nav nav-pills flex-column mb-5 ${this.state.sideBarBig ? '' : 'nav-flush text-center'}`} role="tablist">
                    <li key={"btnSubir"} className="nav-item text-center mb-3">
                        <SubirArchivos 
                            tokenSeguridad={this.state.tokenSeguridad} 
                            ubicacion={this.state.ubicacion}
                            idCarpeta={this.state.idCarpeta}
                            publicKeyRSA={this.state.publicKeyRSA}
                            activeTab={this.state.activeTab}
                            obtenerArchivos={this.obtenerArchivos}
                            sideBarBig={this.state.sideBarBig}
                            movil={false}/>
                    </li>
                    <li key={"menuUsuario"} className="nav-item mb-2" id="menuLateral-nombreUsuario" role="presentation">
                        <a href="#" className={`${this.state.sideBarBig ? 'align-items-center px-1 text-dark text-decoration-none':'px-2 text-dark text-decoration-none text-center'}`} onClick={()=>{
                            if (this.state.sideBarBig) {
                                this.setState({sideBarBig:false});
                            }else{
                                this.setState({sideBarBig:true});
                            } 
                        }}>
                            {this.state.sideBarBig ? <span className="fs-5 fw-bold">{nombreUsuario}</span> : ''}
                            <img className={`${this.state.sideBarBig ? 'cerrarSidebar':''}`} src="../img/abrirSidebar.svg" width={'40'} height={'auto'}/>
                        </a>
                    </li>
                    <li key={"menuInicio"} className="nav-item mb-2" id="menuLateral-inicio" role="presentation">
                        <a href="#" className={`${this.state.sideBarBig ? 'nav-link sideBar d-flex align-items-center p-1':'nav-link sideBar'} ${this.state.activeTab === 'inicio' ? 'active' : ''}`}
                            id="pills-recientes-tab" data-bs-toggle="pill" data-bs-target="#pills-recientes" type="button" role="tab" aria-selected="true" onClick={()=>{
                                this.setState({activeTab:  'inicio', ubicacion: '/'});
                            }}>
                            {this.state.sideBarBig ? 
                                <>
                                    <i className="bi bi-house-door-fill mx-2 iconoSidebar" ></i>
                                    <i className="bi bi-house-door mx-2" ></i>
                                    Inicio
                                </> : 
                                <>
                                    <i className="bi bi-house-door-fill iconoSidebar" ></i>
                                    <i className="bi bi-house-door" ></i>
                                </>
                            }
                        </a>
                    </li>
                    <li key={"menuArchivos"} className="nav-item mb-2" id="menuLateral-EXPLORADOR_ARCHIVOS" role="presentation">
                        <a href="#" className={`${this.state.sideBarBig ? 'nav-link sideBar d-flex align-items-center p-1':'nav-link sideBar'} ${this.state.activeTab === 'archivos' ? 'active' : ''}`}
                            id="pills-explorador-tab" data-bs-toggle="pill" data-bs-target="#pills-explorador" type="button" role="tab" aria-selected="true" onClick={()=>{
                                this.setState({activeTab:  'archivos', ubicacion: '/'});
                            }}>
                            {this.state.sideBarBig ? 
                                <>
                                    <i className="bi bi-folder-fill mx-2 iconoSidebar"></i>
                                    <i className="bi bi-folder mx-2"></i>
                                    Mis Archivos
                                </> : 
                                <>
                                    <i className="bi bi-folder-fill iconoSidebar"></i>
                                    <i className="bi bi-folder"></i>
                                </>
                            }
                        </a>
                    </li>
                    <li key={"menuCompartir"} className="nav-item mb-2" id="menuLateral-compartir" role="presentation">
                        <a href="#" className={`${this.state.sideBarBig ? 'nav-link sideBar d-flex align-items-center p-1':'nav-link sideBar'} ${this.state.activeTab === 'compartir' ? 'active' : ''}`}
                            id="pills-compartir-tab" data-bs-toggle="pill" data-bs-target="#pills-compartir" type="button" role="tab" aria-selected="false" onClick={()=>{
                                this.setState({activeTab:  'compartir', ubicacion: '/'});
                            }}>
                            {this.state.sideBarBig ? 
                                <>
                                    <i className='bi bi-people-fill mx-2 iconoSidebar'></i>
                                    <i className='bi bi-people mx-2'></i>
                                    Compartidos
                                </> : 
                                <>
                                    <i className='bi bi-people-fill iconoSidebar'></i>
                                    <i className='bi bi-people'></i>
                                </>
                            }
                        </a>
                    </li>
                </ul>
                <hr/>
                <div className="mb-3 text-center">
                    <div className="card bg-transparent">
                        {this.state.sideBarBig ?
                        <div className="card-body">
                            <p className="card-text">Obtener espacio para todos tus archivos y fotos.</p>
                            <button className="btn btn-mas text-nowrap text-truncate" id="btnPaquetes" onClick={(e) => {
                                e.preventDefault();
                                this.abrirModal();
                            }}>
                                <i className="bi bi-gem text-primary"></i>  Comprar más espacio
                            </button>
                        </div>
                        :
                        <button className="btn btn-mas text-nowrap text-truncate" id="btnPaquetes" onClick={(e) => {
                                e.preventDefault();
                                this.abrirModal();
                            }}>
                            <i className="bi bi-gem text-primary"></i>
                        </button>
                        }
                    </div>                    
                </div>
                
                <div className="mb-auto text-center">
                    {this.state.sideBarBig ? <span className="fs-5">Espacio</span> : <span></span>}
                    <div>
                        <div className="progress" role="progressbar" aria-valuenow={`${this.state.espacio.pg}`} aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar" style={{width:`${this.state.espacio.pg}%`}}></div>
                        </div>
                    </div>
                    <span className={`${
                        this.state.espacio.pg >= 90 ? 'text-danger' : 
                        this.state.espacio.pg >= 70 ? 'text-warning' : 'text-success'
                    }`}>{this.formatBytes(this.state.espacio.total)} restantes</span>
                </div>
                
                {/* <hr/>
                <div className="dropdown">
                    <a href="#" className="d-flex align-items-center text-white text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="bi bi-person-circle me-2" width="32" height="32"></i>
                        <strong>{sessionStorage.getItem("nombre")}</strong>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-dark text-small shadow">
                        <li key={'cerrarSesion'}><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); sessionStorage.clear(); window.location = "https://neurokratos.space/drive/" }}>Sign out</a></li>
                    </ul>
                </div> */}
            </div>{/* )} */}
            
            <div className="col px-1"  style={{ height: '90vh', width: 'auto'}}>
                <Drive pkey={this.state.publicKeyRSA} 
                    activeTab={this.state.activeTab}
                    ubicacion={this.state.ubicacion} 
                    cambiarUbicacion={this.cambiarUbicacion}
                    idCarpeta={this.state.idCarpeta}
                    regresarDirectorio={this.regresarDirectorio}
                    files={this.state.directorioArchivos}
                    obtenerArchivos={this.obtenerArchivos}
                    activeType={this.state.activeType}
                    movil={false}/>
            </div>
            {this.state.showModal && (
                <div className="modal show d-block" id="PagosModal" tabIndex="-1" data-bs-backdrop="static">
                <div className="modal-backdrop show z-n1"></div>
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="PagosModalLabel">Paquetes</h5>
                    </div>
                    <div className="modal-body">
                        <div className="list-group">
                            <div>
                                {this.state.listaPaquetes}
                                <div className="row">
                                    {this.state.pagoActual != "" ?
                                    <button onClick={() => { return;}} className="btn btn-success">Continuar</button> : null}
                                </div>
                            </div>
                            {/* <BotonPagoDrive id_usuario={sessionStorage.getItem('id_usuario')} precio={this.state.pagoActual.costo} id_precio={this.state.pagoActual.id_precio} />  */}
                        
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button id="CerrarModalPago" onClick={() => { 
                            this.setState({ paquetes: [], pagoActual: "", showModal: false });
                            }} type="button" className="btn btn-secondary">Cerrar</button>
                    </div>
                    </div>
                </div>
                </div>
            )}
        </>);
        /* render = isMobile ? movil : desktop;
        return (render); */
    }
}
export default withRouter(DrivePrincipal);